/**
 * EmulatedStorage is a simple Map emulating Storage.
 * Used in cases where actual browser local/session storage can't be used.
 */
export class EmulatedStorage implements Storage {
  private readonly storage = new Map<string, string>();

  /** Used by tests */
  public itemInsertionCallback?: (keyCount: number) => any;

  public get length(): number {
    return this.storage.size;
  }

  public getItem(key: string): string | null {
    const item = this.storage.get(key);
    return item === undefined ? null : item;
  }

  public setItem(key: string, value: string): void {
    this.storage.set(key, value);
    if (this.itemInsertionCallback) {
      this.itemInsertionCallback(this.length);
    }
  }

  public removeItem(key: string): void {
    this.storage.delete(key);
  }

  public clear(): void {
    return this.storage.clear();
  }

  public key(index: number): string | null {
    const keys: string[] = [];
    for (const k of this.storage.keys()) {
      keys.push(k);
    }
    return keys[index] ?? null;
  }
}
